<template>
  <div class="grid">
    <div class="col-12">
      <Card>
        <template #title>Удаление информационной части(доступен только просмотр)</template>
        <template #content>
          <TabView>
            <TabPanel header="Отчёты на удаление ИЧ">
              <DeleteInformationPartsTable ref="requestsTable"/>
            </TabPanel>
            <TabPanel header="Список заявок с удаленной ИЧ">
              <DeleteInformationPartApplicationsTable ref="applicationsTable"/>
            </TabPanel>
          </TabView>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import DeleteInformationPartsTable from "@/components/tables/DeleteInformationPartsTable.vue";
import DeleteInformationPartApplicationsTable from "@/components/tables/DeleteInformationPartApplicationsTable.vue";

export default {
  name: 'DeleteInformationPart',
  components: {
    DeleteInformationPartApplicationsTable,
    DeleteInformationPartsTable
  },
  methods: {
  }
}
</script>


